import type { WeaponId } from '@graveshift/shared/config';
import type { ValueOf } from '@graveshift/shared/core';

export const ModelKey = {
  HeroPippin: 'hero-pippin',
  HeroWatchman: 'hero-watchman',
  HeroLamplighter: 'hero-lamplighter',
  HeroUndertaker: 'hero-undertaker',
  HeroAgatha: 'hero-agatha',
  Zombie: 'zombie',
  Skeleton: 'skeleton',
  Ghost: 'ghost',
  Brute: 'brute',
  Vampire: 'vampire',
  Keeper: 'keeper',
  GraveRound: 'grave-round',
  GraveCross: 'grave-cross',
  GraveBroken: 'grave-broken',
  GraveWide: 'grave-wide',
  GraveDecorative: 'grave-decorative',
  Crypt: 'crypt',
  Pine: 'pine',
  PineCrooked: 'pine-crooked',
  IronFence: 'iron-fence',
  StoneWall: 'stone-wall',
  Lightpost: 'lightpost',
  Pumpkin: 'pumpkin',
  Rocks: 'rocks',
  Coffin: 'coffin',
  OpenGrave: 'open-grave',
  FireBasket: 'fire-basket',
  Candles: 'candles',
  Coin: 'coin',
  Potion: 'potion',
} as const;
export type StaticModelKey = ValueOf<typeof ModelKey>;
export type WeaponModelKey = `weapon-${WeaponId}`;
export type ModelKey = StaticModelKey | WeaponModelKey;

export function weaponModelKey(weapon: WeaponId): WeaponModelKey {
  return `weapon-${weapon}`;
}
